// used to check for cart limits on products in cart.js and minicart.js
window.cartLimit = 12;

function uuidv4() {
  return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
}

const debounce = (callback, wait) => {
  let timeoutId = null;
  return (...args) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
    callback.apply(null, args);
    }, wait);
  };
}

function trapFocus(modal) {
  function getFocusableElements() {
    const selectors = `
      a[href], area[href], input:not([disabled]):not([type="hidden"]),
      select:not([disabled]), textarea:not([disabled]),
      button:not([disabled]), [tabindex]:not([tabindex="-1"])`;
    return Array.from(modal.querySelectorAll(selectors))
      .filter(el => el.offsetParent !== null); // filter out hidden elements
  }
  function handleFocusTrap(event) {
    if (event.key !== 'Tab') return;

    const focusable = getFocusableElements();
    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey) {
      if (document.activeElement === first || modal === document.activeElement) {
        event.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }
  modal.addEventListener('keydown', handleFocusTrap);
  requestAnimationFrame(() => {
    const focusable = getFocusableElements();
    if (
      focusable.length > 0 &&
      !modal.contains(document.activeElement)
    ) {
      focusable[0].focus();
    }
  });
  return function cleanup() {
    modal.removeEventListener('keydown', handleFocusTrap);
  };
}



function poll(fn, timeout, interval) {
  var endTime = Number(new Date()) + (timeout || 2000);
  interval = interval || 100;

  var checkCondition = function(resolve, reject) {
      var result = fn();
      if(result) {
        resolve(result);
      }
      else if (Number(new Date()) < endTime) {
        setTimeout(checkCondition, interval, resolve, reject);
      }
      else {
          reject(new Error('timed out for ' + fn + ': ' + arguments));
      }
  };

  return new Promise(checkCondition);
}

const __isp_get_customer_identifier_from_klaviyo = () => {
  try {
    const customer_id = _learnq.push(['_getIdentifiers']).$exchange_id;
    if (typeof customer_id !== 'undefined') {
      return customer_id;
    }
    return '';
  } catch (e){
    return '';
  }
}

// CUSTOM PARSER ========================
class CustomParser extends HTMLElement {
  connectedCallback() {
    this.style.whiteSpace = 'pre-wrap';
    const textArea = document.createElement('textarea');
    textArea.innerHTML = this.innerHTML;
    const parsedString = textArea.value;
    this.innerHTML = parsedString;
  }
}

customElements.define('dom-parser', CustomParser);
// END CUSTOM PARSER ========================


function shuffle(array) {
  let currentIndex = array.length, randomIndex;

  while (currentIndex != 0) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }

  return array;
}

function toHandle(str) {
  return str
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

document.addEventListener('DOMContentLoaded', () => {
  const root = document.documentElement;
  const header = document.querySelector('header');
  const section = header?.closest('.shopify-section');
  const main = document.querySelector('#MainContent');
  const group = document.querySelector('.shopify-section-group-header-group');

  let lastY = 0, delta = 0;

  const getMinHeight = () => window.innerWidth < 768 ? 64 : 72;

  setFullHeaderHeight = () => {
    const top = main?.getBoundingClientRect().top || 0;
    if (group) root.style.setProperty('--full-header-height', `${Math.max(top, getMinHeight())}px`);
  }
  
  setFullHeaderHeight();
  
  const setVars = () => {
    const top = main?.getBoundingClientRect().top || 0;
    const offset = main?.offsetTop || 0;

    if (group) root.style.setProperty('--header-height', `${Math.max(top, getMinHeight())}px`);
    root.style.setProperty('--desktop-top', `${window.scrollY > offset ? 0 : offset}px`);
  };

  const onScroll = () => {
    const y = window.scrollY;
    const down = y > lastY;

    if (down) {
      delta += y - lastY;
      if (delta >= 200) {
        section?.classList.add('-translate-y-[200%]');
        root.style.setProperty('--header-height', `0px`);
        root.style.setProperty('--full-header-height', `0px`);
      } else setFullHeaderHeight();
    } else {
      delta = 0;
      section?.classList.remove('-translate-y-[200%]');
      setFullHeaderHeight();
      setVars();
    }

    if (group) document.body.classList.toggle('at-top', y < 200);
    lastY = Math.max(y, 0);
  };

  ['scroll', 'resize', 'load'].forEach(e => window.addEventListener(e, () => {
    onScroll();
    setVars();
  }));
});

document.getElementById('signupSumbit').addEventListener('click', (e) => {
  const emailError = document.getElementById('signupError');
  let state = e.target.getAttribute("type")
  if (state == 'button') {
    emailError.classList.remove('hidden')
  }
});

document.addEventListener('resize', () => {
  const headerGroup = document.querySelector('.shopify-section-group-header-group');
  if (!headerGroup) return;
  document.documentElement.style.setProperty('--header-height', `${headerGroup?.offsetHeight}px`);
});

(() => {
  const headerGroup = document.querySelector('.shopify-section-group-header-group');
  if (!headerGroup) return;
  document.documentElement.style.setProperty('--header-height', `${headerGroup?.offsetHeight}px`);
  const headerFullGroup = [...document.querySelectorAll('.section-header')].reduce((sum, el) => sum + el.offsetHeight, 0);
  const thinPromoBanner = document.querySelector('.thin-promo-banner');
  const thinPromoBannerHeight = (window.scrollY === 0 && thinPromoBanner) ? thinPromoBanner.offsetHeight : 0;
  const totalHeaderHeight = headerFullGroup + thinPromoBannerHeight;
  document.documentElement.style.setProperty('--full-header-height', `${totalHeaderHeight}px`);
}) ();

//Force cart update on back button
window.addEventListener('pageshow', (event) => {
  setTimeout(function(){
    const mini_cart = document.querySelector('mini-cart');
    mini_cart.updateCartHtml();
  }, 100);
});


document.addEventListener('DOMContentLoaded', function() {
  const parallaxContainers = document.querySelectorAll('.parallax-container');

  window.addEventListener('scroll', () => {
    const scrollY = window.scrollY;

    parallaxContainers.forEach(container => {
      const parallaxImages = container.querySelectorAll('.parallax-image');
      const containerTop = container.offsetTop + 70;

      if (scrollY >= containerTop) {
        parallaxImages.forEach(image => {
          const offset = (scrollY - containerTop) * 0.25;
          image.style.transform = `translateY(${offset}px)`;
        });
      } else {
        parallaxImages.forEach(image => {
          image.style.transform = 'translateY(0px)';
        });
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const handleReviewClick = (e) => {
    e.preventDefault();
    document.querySelector('.pr-block')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (!mutation.addedNodes) continue;
      const reviewLink = document.querySelector('.pr-snippet-review-count');
      if (reviewLink) {
        observer.disconnect();
        const newLink = reviewLink.cloneNode(true);
        reviewLink.replaceWith(newLink);
        newLink.addEventListener('click', handleReviewClick);
        break;
      }
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

window.addEventListener('dataLayer:color_change', () => {
  setTimeout(() => {
    const item = JSON.parse(document.getElementById("_learnq_item").innerHTML);
    window._learnq?.push(['track', 'Viewed Product', item]);
    window._learnq?.push(['trackViewedItem', {
      Title: item.Name,
      ItemId: item.ProductID,
      Categories: item.Categories,
      ImageUrl: item.ImageURL,
        Url: item.URL,
        Tags: item.tags,
        Metadata: {
        Brand: item.Brand,
        Price: item.Price,
        CompareAtPrice: item.CompareAtPrice
      } 
    }]);
  }, 100);
});

window.addEventListener('dataLayer:size_select', e => {
  let { selected, current } = e.detail;
  selected = JSON.parse(selected);
  elevarDataLayer('size_select', selected, current);
});

window.addEventListener('dataLayer:color_change', e => {
  let { selected, current } = e.detail;
  selected = JSON.parse(selected);
  elevarDataLayer('color_change', selected, current);  
});

function elevarDataLayer(eventName, selected, current) {
  const cat = localStorage.getItem("___ELEVAR_GTM_SUITE--lastCollectionPathname");
  dataLayer.push({event: 'pageview'});
  dataLayer.push({
    'event': 'dl_view_item_' + eventName,
    'ecommerce': {
      'currencyCode': "USD",
      'detail': {
        'actionField': {
          'list': cat != null ? cat : ''
        },
        'products': [{
          'name': selected.title,
          'id': current.sku,
          'price': String(selected.price / 100),
          'compare_at_price': String(selected.compare_at_price / 100),
          'image': selected.featured_image,
          'brand': selected.brand,
          'list': cat != null ? cat : '',
          'category': selected.type,
          'product_id': selected.id,
          'variant': current.title,
          'variant_id': current.id
        }]
      }
    }
  });
}

const banner = document.getElementById('consent_banner');
const closeBtn = document.getElementById('consent_banner_close');

if (sessionStorage.getItem('consent_banner_closed') !== 'true')  banner?.classList.remove('hidden');

closeBtn?.addEventListener('click', () => {
  sessionStorage.setItem('consent_banner_closed', 'true');
  banner?.classList.add('hidden');
});